import { PasswordType } from 'app/components/Password';
import { IPlayerResponse } from 'types/action/player';
import { IOrganisationConfig, OrganisationStatus } from 'types/domain/organisation';
import { IRoleConfig, Role } from 'types/domain/role';
import { ISearchResponse } from 'types/domain/search';
import { IOrganisationUserBasicDAO } from 'types/domain/user';

export interface IValidateAction {
  token: string;
  refresh: string;
}

export interface IValidateResponse {
  token: string;
  refresh: string;
  orgConfig: IOrganisationConfig;
  cookies: string[];
  role: Role;
  expires: string;
  organisationUserId: number;
  email: string;
  courseId: number;
  organisationStatus: OrganisationStatus;
}

export interface IAuthAction {
  username: string;
  password: string;
  domain: string;
  version: string;
  postAction?: Function;
  token?: string;
  courseNodeId?: number;
}

export interface IGoogleAuthAction {
  googleAuth: any;
  version: string;
  postAction?: Function;
  token?: string;
  courseNodeId?: number;
}

export interface ISystemAction {
  first?: string;
  last?: string;
  systemId?: string;
  email?: string;
  token?: string;
}

export interface IAuthResponse {
  token: string;
  refresh: string;
  role: Role;
  courseId: number;
  name: IName;
  roleConfig: IRoleConfig;
  cookies: string[];
  domainId: number;
  searchResponse: ISearchResponse;
  expires: string;
  email: string;
  avatar: string;
  organisationUserId: number;
  organisationStatus: OrganisationStatus;
}

export interface IName {
  first: string;
  last: string;
}

export interface IResetAction {
  token: string;
  email: string;
  password: string;
  domain: string;
  version: string;
  postAction?: Function;
  returnToken?: string;
  type?: PasswordType;
}

export interface ISignUpAction {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  credential: any;
  recapture: string;
}

export enum AuthState {
  'ERROR' = -1,
  'NOT_LOGGED_IN' = 0,
  'LOGGING_IN' = 1,
  'LOGGED_IN' = 2,
}

export enum ValidateState {
  'ERROR' = -1,
  'NOT_VALIDATED' = 0,
  'VALIDATING' = 1,
  'VALIDATED' = 2,
}
